import { _ } from "../../../../helpers/dom-selectors.js";
import makeForm from "../../../global-components/form.js";
import APP_EVENTS from "../init/events.js";
const SignupForm = makeForm({
    form: _('signupForm'),
    submitBtn: _('signupBtn'),
    preventDefault: true,
    events: APP_EVENTS,
    action: 'signup-form-submitted',
});
export default SignupForm;
